import React from 'react';
import clsx from 'clsx';

type ImageProps = {
  imageUrl?: string;
  title?: string;
  className?: string;
  imageClassName?: string;
};

export const Image: React.FC<ImageProps> = ({
  imageUrl,
  title,
  className,
  imageClassName,
}) => {
  return (
    <div className={clsx(className)}>
      <img
        src={imageUrl}
        alt={title || ''}
        className={clsx(imageClassName, 'w-full')}
      />
    </div>
  );
};
